import { useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { BUSINESS } from "@/lib/data";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "New Boilers", href: "#new-boilers" },
  { label: "Plumbing", href: "#plumbing" },
  { label: "Book Online", href: "#booking" },
  { label: "Free Quote", href: "#quote" },
  { label: "Our Work", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="site-nav" className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-4 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center shrink-0 mr-4 group">
          <img src="/images/logo-flame.png" alt="Teign Gas" className="h-9 w-9 sm:hidden mix-blend-screen" />
          <img
            src="/images/logo-mark.png"
            alt="Teign Gas — Service, Repair, Install"
            className="hidden sm:block h-7 xl:h-8 w-auto mix-blend-screen group-hover:drop-shadow-[0_0_18px_rgba(255,85,0,0.45)] transition-all"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-4 xl:gap-5">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-neutral-400 hover:text-torch transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={BUSINESS.phoneHref}
            data-testid="nav-phone-link"
            className="hidden 2xl:flex items-center gap-2 font-mono text-xs tracking-wider text-neutral-300 border border-neutral-700 px-4 py-2.5 rounded-sm hover:border-torch hover:text-torch transition-colors whitespace-nowrap"
          >
            <Phone className="w-3.5 h-3.5" />
            {BUSINESS.phone}
          </a>
          <a
            href="#booking"
            data-testid="nav-book-btn"
            className="bg-torch hover:bg-torch-hover text-white font-display font-bold text-sm uppercase tracking-wide px-5 py-2.5 rounded-sm transition-all hover:shadow-[0_0_28px_rgba(255,85,0,0.45)] whitespace-nowrap shrink-0"
          >
            Book Online
          </a>
          <button
            data-testid="nav-menu-toggle"
            className="lg:hidden text-neutral-300 p-1"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="nav-mobile-menu" className="lg:hidden border-t border-white/10 bg-black/95 px-6 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-mono text-sm uppercase tracking-[0.2em] text-neutral-300 hover:text-torch transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a href={BUSINESS.phoneHref} className="font-mono text-sm text-torch">{BUSINESS.phone}</a>
        </nav>
      )}
    </header>
  );
};
